export const namespace = 'boxTypes';

export const MutationTypes = {
  SET_BOX_TYPES: 'SET_BOX_TYPES',
  SET_BOX_TYPES_TOTAL_COUNT: 'SET_BOX_TYPES_TOTAL_COUNT',
};

export const ActionTypes = {
  GET_BOX_TYPES: 'GET_BOX_TYPES',
};
